import { IFrameStore } from '@rift/service/validation/database/syncrecording/IFrameStore';
import { IObjectStore } from '@shared/service/Indexeddb/IObjectStore';

export interface IDatabaseTargetFramesStore extends IFrameStore {
}

export class DatabaseTargetFramesStore implements IObjectStore {
    public static readonly keyPath: string = 'id';
    public static readonly recordingIdBlockIndex: string = 'RecordingIdBlockIndex';
    public static readonly recordingIdFrameNumberIndex: string = 'RecordingIdFrameNumberIndex';
    public static readonly recordingIdIndex: string = 'RecordingIdIndex';
    public static readonly recordingIdTimestamp: string = 'RecordingIdTimestamp';
    public static readonly storeDisplayName: string = 'Targets';
    public static readonly storeName: string = 'target';

    public get storeName(): string {
        return DatabaseTargetFramesStore.storeName;
    };

    public static toInterface(): IDatabaseTargetFramesStore {
        return {
            storeName: this.storeName,
            keyPath: this.keyPath,
            recordingIdFrameNumberIndex: this.recordingIdFrameNumberIndex,
            recordingIdIndex: this.recordingIdIndex,
            recordingIdBlockIndex: this.recordingIdBlockIndex,
        } as IDatabaseTargetFramesStore;
    }

    public createStores(db: IDBDatabase): void {
        const store: IDBObjectStore = db.createObjectStore(DatabaseTargetFramesStore.storeName, { keyPath: DatabaseTargetFramesStore.keyPath, autoIncrement: true });
        store.createIndex(DatabaseTargetFramesStore.recordingIdFrameNumberIndex, ['recordingId', 'frameNumber'], { unique: true });
        store.createIndex(DatabaseTargetFramesStore.recordingIdBlockIndex, ['recordingId', 'block']);
        store.createIndex(DatabaseTargetFramesStore.recordingIdIndex, 'recordingId');
    }
}
